import type { AxiosRequestConfig } from 'axios'

const normalizeRequestHeaderValue = (value: unknown): string => {
  if (typeof value === 'string') {
    return value
  }

  if (value === null) {
    return ''
  }

  return String(value)
}

export const getRequestHeaderFromConfig = (config: AxiosRequestConfig | undefined, headerName: string): string => {
  const headers = config?.headers

  if (!headers) {
    return ''
  }

  if (typeof headers === 'object' && 'get' in headers && typeof headers.get === 'function') {
    const value = headers.get(headerName) ?? headers.get(headerName.toLowerCase())

    return normalizeRequestHeaderValue(value)
  }

  const record = headers as Record<string, unknown>
  const value = record[headerName] ?? record[headerName.toLowerCase()]

  return normalizeRequestHeaderValue(value)
}
